import { PROTOCOL_VERSION_CURRENT } from './constants';
import { ProtocolValidationError } from './protocol-errors';

export function validateVersion(version: number): void {
  if (version !== PROTOCOL_VERSION_CURRENT) {
    throw new ProtocolValidationError(
      `Unsupported protocol version: ${version}. Client is on version ${PROTOCOL_VERSION_CURRENT}`
    );
  }
}
